module.exports = __webpack_public_path__ + "img/op_img-header-mobile.08aec88.png";